export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:8001';

export const GUEST_USER = {
  id: 0,
  username: 'DebtSlayer',
  email: 'guest@debtfightclub.com',
};

export function isGuestMode(): boolean {
  return localStorage.getItem('guest_mode') === 'true';
}

export function enterGuestMode(): typeof GUEST_USER {
  localStorage.setItem('guest_mode', 'true');
  localStorage.setItem('user_info', JSON.stringify(GUEST_USER));
  return GUEST_USER;
}

export function clearGuestMode(): void {
  localStorage.removeItem('guest_mode');
}
